import React, { useState, useEffect, useRef } from "react";
import { FaInstagram, FaWhatsapp, FaApple } from "react-icons/fa";
import { IoMailSharp } from "react-icons/io5";
import { RiFacebookCircleLine } from "react-icons/ri";
import { message, Modal, Form, Input } from "antd";
import { useLoading } from "../../Services/loadingService";
import { useParams } from "react-router-dom";
import { FaLinkedin, FaShare, FaChevronDown, FaChevronUp, FaRegCalendarAlt } from "react-icons/fa";
import defaultimage from "../../Assets/Images/Notfound.png";
import { Theme001, Theme002, Theme003, Theme004 } from "./ThemeLayout";
import { logInstance } from "../../AxiosConfig";
import QRCode from "react-qr-code";
import BookAppointmentModal from "../BookAppointment/BookAppointmentModal";

const GooglePlayIcon = ({ size = 20 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 27">
    <path d="M0.432 0.607C0.16 0.9 0 1.347 0 1.928v23.146c0 .58.16 1.027.432 1.32L.504 26.459 13.282 13.68v-.314L.504.545l-.072.062z" fill="#00D3FF"/>
    <path d="M17.604 17.968l-4.321-4.322v-.313l4.321-4.322.097.056 5.12 2.91c1.46.83 1.46 2.19 0 3.02l-5.12 2.91-.097.06z" fill="#FFD400"/>
    <path d="M17.7 17.912L13.282 13.5.432 26.393c.48.51 1.277.572 2.166.065L17.7 17.912z" fill="#FF4956"/>
    <path d="M17.7 9.088L2.598.543C1.709.037.912.1.432.607L13.282 13.5 17.7 9.088z" fill="#00EE74"/>
  </svg>
);

const ProductItem = ({ product, cardColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const descRef = useRef(null);

  useEffect(() => {
    if (descRef.current) {
      setIsClamped(descRef.current.scrollHeight > descRef.current.clientHeight);
    }
  }, []);

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #eee",
        borderRadius: 12,
        padding: 12,
      }}
    >
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
        {product.image && (
          <img
            src={product.image}
            alt={product.name}
            style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 8, flexShrink: 0 }}
          />
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          <h4 style={{ fontSize: 14, fontWeight: 600, color: "#1a1a1a", margin: "0 0 2px", textTransform: "capitalize" }}>
            {product.name}
          </h4>
          {product.price !== undefined && product.price !== null && (
            <p style={{ margin: "0 0 4px", fontSize: 13, fontWeight: 700, color: "#0177db" }}>
              {product.currency === "INR" ? "₹" : product.currency === "USD" ? "$" : product.currency === "EUR" ? "€" : product.currency === "GBP" ? "£" : (product.currency + " ")}
              {Number(product.price).toLocaleString("en-IN")}
            </p>
          )}
          <p
            ref={descRef}
            style={{
              fontSize: 12,
              color: "#777",
              margin: "0 0 2px",
              lineHeight: 1.4,
              display: isExpanded ? "block" : "-webkit-box",
              WebkitLineClamp: isExpanded ? "unset" : 2,
              WebkitBoxOrient: "vertical",
              overflow: isExpanded ? "visible" : "hidden",
            }}
          >
            {product.description}
          </p>
          {isClamped && (
            <span
              onClick={() => setIsExpanded((p) => !p)}
              style={{ color: "#2986D6", fontSize: 12, fontWeight: 600, cursor: "pointer" }}
            >
              {isExpanded ? "See less" : "See more"}
            </span>
          )}
        </div>
      </div>
      {(product.checkoutUrl || product.bookingUrl) && (
        <div style={{ marginTop: 10, marginLeft: product.image ? 76 : 0 }}>
          <a
            href={product.checkoutUrl || product.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "5px 14px",
              background: cardColor || "#2986D6",
              color: "#fff",
              borderRadius: 4,
              fontSize: 11,
              fontWeight: 600,
              textDecoration: "none",
              letterSpacing: 0.5,
            }}
          >
            {product.checkoutUrl ? "BUY NOW" : "BOOK NOW"}
          </a>
        </div>
      )}
    </div>
  );
};

const ProfileCard = () => {
  const [cardsData, setCardsData] = useState({});
  const [products, setProducts] = useState([]);
  const [userImage, setUserImage] = useState("");
  const [isFlipped, setIsFlipped] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const [qrModal, setQrModal] = useState({ visible: false, value: "" });
  const [formLoading, setFormLoading] = useState(false);
  const [bookingVisible, setBookingVisible] = useState(false);

  const { startLoading, stopLoading } = useLoading();
  const { id } = useParams();

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);

  const onFinish = (values) => {
    setFormLoading(true);
    logInstance
      .post("/profile-form/submit", {
        userId: cardsData.userId,
        name: values.name,
        phnNumber: values.phnNumber,
      })
      .then(() => {
        message.success("Contact shared successfully!");
        setIsModalVisible(false);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        message.error("Failed to share contact. Please try again.");
      })
      .finally(() => setFormLoading(false));
  };

  const fetchCardsData = () => {
    startLoading();
    logInstance
      .get(`/card/cardId/${id}`)
      .then((response) => {
        console.log("response", response);
        setCardsData(response?.data?.card || {});
        setProducts(response?.data?.products || []);
        setUserImage(response?.data?.userImage || "");
      })
      .catch((error) => {
        console.error("Error fetching Data:", error);
      })
      .finally(() => stopLoading());
  };

  useEffect(() => {
    fetchCardsData();
  }, []);

  const generateVCF = () => {
    if (!cardsData) return;
    const yourName = cardsData.yourName || "No Name Available";
    const businessName = cardsData.businessName || "";
    const designation = cardsData.designation || "";
    const mobile = cardsData.mobile || "";
    const whatsapp = cardsData.whatsappNo || "";
    const email = cardsData.email || "";
    const website = cardsData.website ? `https://${cardsData.website}` : "";
    const fullName =
      [yourName, designation, businessName].filter(Boolean).join(" ") ||
      "No Name Available";
    const vcfData = `BEGIN:VCARD
VERSION:3.0
N:${fullName}
FN:${fullName}
ORG:${businessName}
TITLE:${designation}
TEL;TYPE=CELL:${mobile}
${whatsapp ? `TEL;TYPE=WHATSAPP:${whatsapp}` : ""}
EMAIL:${email}
${website ? `URL:${website}` : ""}
END:VCARD`.trim();

    const blob = new Blob([vcfData], { type: "text/vcard" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fullName}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleLinkClick = (event, link) => {
    if (!link) {
      event.preventDefault();
      message.error("Not Found");
    }
  };

  const shareCard = async () => {
    const shareUrl = `https://knowconnections.com/profile-card/${id}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: cardsData.businessName || "Digital Business Card",
          text: "Check out my digital business card",
          url: shareUrl,
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          navigator.clipboard.writeText(shareUrl);
          message.success("Link copied!");
        }
      }
    } else {
      navigator.clipboard.writeText(shareUrl);
      message.success("Link copied to clipboard!");
    }
  };

  const themeLayouts = {
    "001": Theme001,
    "002": Theme002,
    "003": Theme003,
    "004": Theme004,
  };

  const ThemeComponent = themeLayouts[cardsData.theme] || Theme001;
  const cardColor = cardsData.color ? `#${cardsData.color.slice(2)}` : "#2986D6";

  const isLightColor = (hex) => {
    const h = hex.replace("#", "");
    if (h.length < 6) return false;
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.85;
  };

  const buttonColor = isLightColor(cardColor) ? "#2986D6" : cardColor;
  const displayProducts = products.slice(0, visibleCount);
  const subtitle = [cardsData.designation, cardsData.businessName]
    .filter(Boolean)
    .join(" at ");

  const socialLinks = [
    { href: "https://www.instagram.com/know_connections/", icon: <FaInstagram />, color: "#E1306C" },
    { href: "https://www.facebook.com/knowconnections7", icon: <RiFacebookCircleLine />, color: "#1877F2" },
    { href: "https://wa.me/919742314395", icon: <FaWhatsapp />, color: "#25D366" },
    { href: "https://www.linkedin.com/company/know-connections", icon: <FaLinkedin />, color: "#0077B5" },
  ];

  return (
    <div
      style={{
        background: "#f5f6fa",
        maxWidth: 480,
        margin: "0 auto",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
        paddingBottom: 90,
      }}
    >
      {/* ── Profile Header ── */}
      <div style={{ background: "#fff", position: "relative" }}>
        {/* Gradient banner */}
        <div
          style={{
            width: "100%",
            maxWidth: 426,
            height: 77,
            background: "linear-gradient(90deg, #EFF6FE 0%, #E6E6FA 100%)",
            margin: "0 auto",
            opacity: 1,
          }}
        />

        {/* Avatar — centered, overlapping banner bottom */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          {userImage ? (
            <img
              src={userImage}
              alt={cardsData.yourName}
              style={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #fff",
                marginTop: -40,
                position: "relative",
                zIndex: 1,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            />
          ) : (
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "#2986D6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 30,
                fontWeight: "bold",
                color: "#fff",
                border: "3px solid #fff",
                marginTop: -40,
                position: "relative",
                zIndex: 1,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              {(cardsData.yourName || "K").charAt(0).toUpperCase()}
            </div>
          )}
        </div>

        {/* Name + designation */}
        <div
          style={{
            width: "100%",
            maxWidth: 396,
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "10px 16px 10px",
          }}
        >
          <h1
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: 32,
              fontWeight: 700,
              fontStyle: "normal",
              lineHeight: "140%",
              letterSpacing: "-0.01em",
              color: "#1a1a1a",
              margin: 0,
              textAlign: "center",
            }}
          >
            {cardsData.yourName || "Name"}
          </h1>
          {subtitle && (
            <p
              style={{
                fontSize: 16,
                color: "#666",
                margin: "4px 0 0",
                textAlign: "center",
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* ── Flip Card ── */}
      <div
        style={{
          margin: "6px 16px 0",
          borderRadius: 16,
          overflow: "visible",
        }}
      >
        <div
          className="flip-container"
          onClick={() => setIsFlipped(!isFlipped)}
          style={{
            cursor: "pointer",
          }}
        >
          <div className={`flipper ${isFlipped ? "flipped" : ""}`}>
            <ThemeComponent
              cardsData={cardsData}
              defaultimage={defaultimage}
              onQrClick={(val) => setQrModal({ visible: true, value: val })}
            />
          </div>
        </div>
      </div>

      {/* ── Buttons ── */}
      <div style={{ display: "flex", gap: 12, padding: "10px 16px 0", boxSizing: "border-box", width: "100%" }}>
        <button
          onClick={generateVCF}
          style={{
            flex: 1,
            minWidth: 0,
            height: 48,
            padding: "10px 0",
            border: `1px solid ${buttonColor}`,
            borderRadius: 10,
            background: buttonColor,
            color: "#fff",
            fontWeight: 600,
            fontSize: 14,
            cursor: "pointer",
            boxSizing: "border-box",
          }}
        >
          Save Contact
        </button>
        <button
          onClick={showModal}
          style={{
            flex: 1,
            minWidth: 0,
            height: 48,
            padding: "10px 0",
            border: `1px solid ${buttonColor}`,
            borderRadius: 10,
            background: "#fff",
            color: buttonColor,
            fontWeight: 600,
            fontSize: 14,
            cursor: "pointer",
            boxSizing: "border-box",
          }}
        >
          Share Contact
        </button>
      </div>


      {/* ── Bio (always visible) ── */}
      {cardsData.aiDescription && (
        <div
          style={{
            margin: "10px 16px 0",
            padding: "12px 16px",
            background: "#EFF6FF",
            borderRadius: 12,
            border: "1px solid #0A66C2",
          }}
        >
          <p
            style={{
              fontSize: 13,
              color: "#555",
              lineHeight: 1.7,
              margin: 0,
            }}
          >
            {cardsData.aiDescription}
          </p>
        </div>
      )}

      {/* ── Products & Services ── */}
      {displayProducts.length > 0 && (
        <div style={{ padding: "24px 16px 0" }}>
          <h3
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: "#1a1a1a",
              margin: "0 0 14px",
            }}
          >
            Products and services
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {displayProducts.map((product) => (
              <ProductItem key={product._id} product={product} cardColor={cardColor} />
            ))}
          </div>
          {/* Show Next */}
          {visibleCount < products.length && (
            <button
              onClick={() => setVisibleCount((c) => c + 1)}
              style={{
                display: "block",
                width: "100%",
                marginTop: 12,
                padding: "10px 0",
                background: "#fff",
                border: `1.5px solid ${cardColor}`,
                borderRadius: 8,
                color: cardColor,
                fontWeight: 600,
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              Show Next ({products.length - visibleCount} remaining)
            </button>
          )}
        </div>
      )}

      {/* ── Why Use KC ── */}
      <div
        style={{
          margin: "24px 16px 0",
          background: "#FFFFFF",
          borderRadius: 12,
          padding: "20px 18px",
          border: "1px solid #E8E8E8",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          opacity: 1,
        }}
      >
        <h3
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#1a1a1a",
            margin: "0 0 16px",
          }}
        >
          Why Use KC (Know Connections)!
        </h3>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {[
            "Effortless Contact Sharing & Organization",
            "Stay Connected with Your Network & Team",
            "Smart Contact Management for Business Growth",
            `Join ${cardsData.businessName || "KC"} Today & Simplify Networking!`,
          ].map((item, i) => (
            <div
              key={i}
              style={{ display: "flex", alignItems: "flex-start", gap: 10 }}
            >
              <span
                style={{
                  color: "#4CAF50",
                  fontWeight: 700,
                  fontSize: 16,
                  flexShrink: 0,
                  marginTop: 1,
                }}
              >
                ✓
              </span>
              <span style={{ fontSize: 14, color: "#333", lineHeight: 1.5 }}>
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Invite / Let's Connect ── */}
      <div
        style={{
          margin: "24px 16px 0",
          background: "#FFFFFF",
          borderRadius: 12,
          padding: "20px 16px",
          opacity: 1,
          boxShadow: "0px 0px 0px 0.5px #00000008, 0px 5px 22px 0px #0000000A",
        }}
      >
        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 14,
            fontWeight: 600,
            color: "#111927",
            lineHeight: "20px",
            letterSpacing: 0,
            margin: "0 0 16px",
          }}
        >
          Invite friends and family to KC (Know Connections) - seamless
          connections when you have everyone on KC (Know Connections)
        </p>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
          {/* Let's Connect button */}
          <button
            onClick={() => window.open("https://knowconnections.com/contact/", "_blank")}
            style={{
              height: 32,
              padding: "0 14px",
              background: "#375DFB",
              border: "none",
              borderRadius: 6,
              color: "#fff",
              fontWeight: 600,
              fontSize: 13,
              cursor: "pointer",
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 0px 0px 1px #375DFB, 0px 1px 2px 0px #253EA77A",
              whiteSpace: "nowrap",
            }}
          >
            Let's Connect
          </button>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            {socialLinks.map((s, i) => (
              <a
                key={i}
                href={s.href || "#"}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => handleLinkClick(e, s.href)}
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  background: s.color,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: 12.33,
                  textDecoration: "none",
                  flexShrink: 0,
                }}
              >
                {s.icon}
              </a>
            ))}
            <button
              onClick={() => {
                const url = window.location.href;
                if (navigator.share) {
                  navigator.share({ title: cardsData.businessName || "Digital Business Card", url }).catch(() => {
                    navigator.clipboard.writeText(url);
                    message.success("Link copied!");
                  });
                } else {
                  navigator.clipboard.writeText(url);
                  message.success("Link copied to clipboard!");
                }
              }}
              style={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                background: "#2986D6",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 12.33,
                cursor: "pointer",
                flexShrink: 0,
              }}
            >
              <FaShare />
            </button>
          </div>
        </div>
      </div>

      {/* ── Download App ── */}
      <div style={{ padding: "24px 16px 40px", textAlign: "center" }}>
        <h2
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 24,
            fontWeight: 600,
            fontStyle: "normal",
            lineHeight: "100%",
            letterSpacing: 0,
            textTransform: "capitalize",
            color: "#191919",
            marginBottom: 16,
          }}
        >
          Download App
        </h2>
        <div
          style={{
            display: "flex",
            gap: 20,
            justifyContent: "center",
            width: 260,
            height: 40,
            margin: "0 auto",
            background: "#FFFFFF",
            borderRadius: 6,
          }}
        >
          <a
            href="https://play.google.com/store/apps/details?id=apps.knowconnections.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 7,
                width: 120,
                height: 40,
                padding: "0 10px",
                border: "1px solid #ddd",
                borderRadius: 6,
                background: "#fff",
                boxSizing: "border-box",
              }}
            >
              <GooglePlayIcon size={20} />
              <div style={{ textAlign: "left" }}>
                <div style={{ fontSize: 9, color: "#888", lineHeight: 1.2 }}>GET IT ON</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#1a1a1a", lineHeight: 1.2 }}>
                  Google Play
                </div>
              </div>
            </div>
          </a>
          <a
            href="https://apps.apple.com/in/app/know-connections/id6741457754"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 7,
                width: 120,
                height: 40,
                padding: "0 10px",
                border: "1px solid #ddd",
                borderRadius: 6,
                background: "#fff",
                boxSizing: "border-box",
              }}
            >
              <FaApple style={{ fontSize: 18, color: "#333", flexShrink: 0 }} />
              <div style={{ textAlign: "left" }}>
                <div style={{ fontSize: 9, color: "#888", lineHeight: 1.2 }}>Download on the</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#1a1a1a", lineHeight: 1.2 }}>
                  App Store
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>

      {/* ── Sticky Book Appointment Pill ── */}
      {/* <div
        style={{
          position: "fixed",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 100,
          pointerEvents: "none",
          width: "100%",
          maxWidth: 480,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <button
          onClick={() => setBookingVisible(true)}
          style={{
            pointerEvents: "auto",
            display: "flex",
            alignItems: "center",
            gap: 10,
            background: "#fff",
            border: "none",
            borderRadius: 28,
            padding: "10px 22px 10px 10px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: 600,
            color: "#1a1a1a",
          }}
        >
          <div style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "#2986D6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: 17,
            flexShrink: 0,
          }}>
            <FaRegCalendarAlt />
          </div>
          Book Appointment
        </button>
      </div> */}
      <BookAppointmentModal
        visible={bookingVisible}
        onClose={() => setBookingVisible(false)}
        userId={cardsData.userId}
        cardId={cardsData._id}
        cardOwnerName={cardsData.yourName || ''}
        businessName={cardsData.businessName || ''}
        cardImage={cardsData.image || ''}
      />

      {/* ── Share Contact Modal ── */}
      <Modal
        title="Share Your Contact"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <Form
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ name: "", phnNumber: "" }}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phnNumber"
            rules={[
              { required: true, message: "Please enter your phone number" },
              {
                pattern: /^\d{10}$/,
                message: "Please enter a valid 10-digit phone number",
              },
            ]}
          >
            <Input placeholder="Enter your phone number" />
          </Form.Item>
          <Form.Item>
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "11px 0",
                background: "#2986D6",
                border: "none",
                borderRadius: 8,
                color: "#fff",
                fontWeight: 600,
                fontSize: 14,
                cursor: "pointer",
                marginTop: 10,
              }}
              disabled={formLoading}
            >
              {formLoading ? "Submitting..." : "Submit"}
            </button>
          </Form.Item>
        </Form>
      </Modal>

      {/* ── QR Code Popup ── */}
      <Modal
        open={qrModal.visible}
        onCancel={() => setQrModal({ visible: false, value: "" })}
        footer={null}
        centered
        width={260}
        title="Scan QR Code"
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "16px 0 8px" }}>
          {qrModal.value && (
            <>
              <QRCode value={qrModal.value} size={180} />
              <p style={{ marginTop: 14, fontSize: 13, color: "#555", textAlign: "center", wordBreak: "break-all" }}>
                {qrModal.value}
              </p>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ProfileCard;
